import React, { useEffect, useState } from 'react';
import {Filter,SelectInput,DateInput,SearchInput,useNotify,minLength,maxLength} from 'react-admin';
import {  deviseFiltre ,status,json} from '../references.js';

const FiltreVersement=(props)=>{
    const [usersWhoSendMe, setUsersWhoSendMe] = useState();
    const [usersWhomRecepFrom, setUsersWhomRecepFrom] = useState();

    const notify = useNotify();

    useEffect(() => {
        fetch(process.env.REACT_APP_URL+'/user/getUsersWhoSendMeRecepFrom', { method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": "Bearer "+ localStorage.getItem('token')
                }
            }
        ).then(json)
        .then((data) => {
            //console.log(data);
            setUsersWhoSendMe(data.listUserWhoSendMeVst);
            setUsersWhomRecepFrom(data.listUserRecepFromVst);
        }).catch((e) => {
            notify("Erreur lors du processus de récupération de la liste des agents m'ayant envoyé un versement !", 'warning')
        });
        
    }, []);

/*
    componentDidMount(){
        var  list_camps=[];
        var camps =JSON.parse(localStorage.getItem('camps'));
       
        if(camps){
            camps=camps.filter(item=>item.type==='AERIEN');
            camps=_.orderBy(camps, ['id'],['desc']);
            camps.forEach((item, index) => {
                list_camps[index] = { id: item.id, name: item.code };
            })
        }

        this.setState({list_camps:list_camps},()=>{});
     }
     */


    //const {l_ag_dest,roles}=this.state;
    return (
        <Filter {...props} >
            <SearchInput source="code" alwaysOn  validate={[minLength(6),maxLength(6)]} />
            <DateInput source="start_date" label="Date début"  alwaysOn />
            <DateInput source="end_date" label="Date fin"  alwaysOn />
            <SelectInput
                source="type"
                label="Versement" 
                choices={[
                    { id: 'tous', name: 'Tous' },
                    { id: 'recu', name: 'Reçu' },
                    { id: 'envoye', name: 'Envoyé' }
                ]}
                
            />
            <SelectInput
                source="status"
                label="Status" 
                choices={status}
                
            />
            {//has_role(JSON.parse(localStorage.getItem('roles')),'ROLE_MANAGER')  ?
             <SelectInput
                source="user_sender_id"
                label="Crée par" 
                choices={usersWhoSendMe}
            /> 
            //: null
            }
            <SelectInput
                source="user_recep_id"
                label="Reception par" 
                choices={usersWhomRecepFrom}
            />

            <SelectInput
                source="devise"
                label="Devise" 
                choices={deviseFiltre}
            />
            
        </Filter>
    );

    
}

export default FiltreVersement;